class ProductDescription extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('.product-description__content');
    this.toggleButton = this.querySelector('[data-product-description-toggle]');
    if (!this.content || !this.toggleButton) return;

    this.toggleButton.addEventListener('click', this.#toggle);
    window.addEventListener('resize', this.#scheduleMeasurement);
    document.fonts?.ready.then(this.#scheduleMeasurement);
    this.#scheduleMeasurement();
  }

  disconnectedCallback() {
    this.toggleButton?.removeEventListener('click', this.#toggle);
    window.removeEventListener('resize', this.#scheduleMeasurement);
    cancelAnimationFrame(this.resizeFrame);
  }

  #toggle = () => {
    const willExpand = this.content.classList.contains('is-collapsed');
    this.content.classList.toggle('is-collapsed', !willExpand);
    this.toggleButton.setAttribute('aria-expanded', String(willExpand));
    this.toggleButton.textContent = willExpand ? this.dataset.lessLabel : this.dataset.moreLabel;
  };

  #scheduleMeasurement = () => {
    cancelAnimationFrame(this.resizeFrame);
    this.resizeFrame = requestAnimationFrame(() => this.#measureOverflow());
  };

  #measureOverflow() {
    const wasCollapsed = this.content.classList.contains('is-collapsed');
    this.content.classList.add('is-collapsed');
    const collapsedHeight = this.content.getBoundingClientRect().height;
    this.content.classList.remove('is-collapsed');
    const fullHeight = this.content.getBoundingClientRect().height;
    this.content.classList.toggle('is-collapsed', wasCollapsed);

    const hasOverflow = fullHeight > collapsedHeight + 1;
    this.toggleButton.hidden = !hasOverflow;
    if (!hasOverflow) {
      this.content.classList.remove('is-collapsed');
      this.toggleButton.setAttribute('aria-expanded', 'true');
    }
  }
}

if (!customElements.get('product-description')) {
  customElements.define('product-description', ProductDescription);
}
